import { type CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { IdentityStore } from '../store/identity.store';

// The session is resolved by a blocking app initializer (see app.config.ts), so by the time this
// runs the session query has already settled — a synchronous check is enough.
export const authGuard: CanActivateFn = () => {
    const store = inject(IdentityStore);
    const router = inject(Router);
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) return true;

    return store.isAuthenticated() ? true : router.createUrlTree(['/iniciar-sesion']);
};
